import React from 'react';
import './SlotCardStyles.css';
function SlotCard({ className, day, date, id, name, checked, onChange, slotsCount }) {
    return (
        <label className={`SlotCardWrapperBox`} htmlFor={id}>
            <input type="radio" name={name} id={id} checked={checked} onChange={onChange} />
            <div className="SlotCardWrapper">
                <div className="bodySlotarea">
                    <span className='Weekdays'>{day}</span>
                    <h4>{date}</h4>
                </div>
                <div className={`FooterSlotCard ${className}`} >
                    {slotsCount} slots
                </div>
            </div>
        </label>
    )
}

export default SlotCard